import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "core-modules-options"
    }}>{`Core Modules Options`}</h1>
    <p>{`Argument and return type objects for `}<a parentName="p" {...{
        "href": "/photoshop/uxp/2022/ps_reference/media/photoshopcore/"
      }}>{`core`}</a>{` functions.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      